<template>
  <QuestionBase :errors="[...serverErrors, ...jsErrors, ...errorsPost]"
                :question="question"
                :valid="data !== null">
    <InputRadio v-model="data"
                :args="args"
                :db="db"
                :options="booleanYesNo"
                :skipped="skipped"
                :no-save="noSave"
                @jsErrors="jsErrors=$event"
                @serverErrors="serverErrors=$event"
                @skipped="skipped=$event" />
  </QuestionBase>
</template>

<script>
import {willRelationshipHelpers} from "../../../../../fieldsets/will/helpers/willRelationshipHelpers";
import {willPeopleHelpers} from "../../../../../fieldsets/will/helpers/willPeopleHelpers";
import {questionLoadHelpers} from "../../../../helpers/questionLoadHelpers";
import {general} from "../../../../options/general";

import QuestionBase from "../../../../QuestionBase";
import InputRadio from "../../../../inputs/InputRadio";
import {personHelpers} from "@/mixins/personHelpers";
import {textHelpers} from "@/mixins/textHelpers";

export default {
  name: 'IndexedYN',
  mixins: [
    general,
    questionLoadHelpers,
    willPeopleHelpers,
    willRelationshipHelpers,
    personHelpers,
    textHelpers
  ],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: [Boolean],
      required: false
    },
    noSave: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      required: false
    },
    errorsPost: {
      type: Array,
      default: () => {
        return []
      }
    },
    location: {
      type: String,
      required: true
    },
    giftDetails: {
      type: Object,
      required: true
    },
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input',
            value)
      },
      get() {
        return this.value
      }
    },
    question() {
      return {
        title: 'Should the amount be adjusted with inflation?',
        subTitle: this.giftDetails.amount ? `If you select 'Yes' actual amount payable will be adjusted to compensate for inflation. For example your gift of £${this.giftDetails.amount} would be £${Math.round(this.giftDetails.amount * (Math.pow((1+(2)/100), 10)))} in 10 years from now (assuming inflation averages 2%).` : `If you select 'Yes' actual amount paid will be adjusted to compensate for inflation, meaning in the future the amount will likely be higher.`,
        tip: null
      }
    },
  },
  data() {
    return {
      db: {
        saveLocation: 'product_will_data',
        saveField: `${this.location}${this.index}Indexed`,
        formPath: `data.${this.location}.details.gifts.${this.index}.indexed`,
        jsonSaveField: 'indexed',
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
